import React from 'react';
import { Title, Text, ResponsiveText, LeftFooterContainer, RightFooterContainer, Section, LogoContainer, LogoImage, ScrollUp } from './styles';
import Email from '../../assets/Footer/Email.png';
import Facebook from '../../assets/Footer/Facebook.png';
import Instagram from '../../assets/Footer/Instagram.png';
import LinkedIn from '../../assets/Footer/LinkedIn.png';
import UpArrow from '../../assets/Footer/UpArrow.png';
import { EXTERNAL_LINKS } from '../../utils/links';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };  
  
  return (
    <Section>
      <LeftFooterContainer>
        <a href={EXTERNAL_LINKS['DH_MAIN']} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
          <Title> DUBHACKS</Title>
          <Text>Building Tomorrow Together</Text>
        </a>
      </LeftFooterContainer>
      <RightFooterContainer>
        <LogoContainer>
          <a href={EXTERNAL_LINKS['DH_EMAIL']} target="_blank" rel="noopener noreferrer">
            <LogoImage src={Email} alt="Email Logo" />
          </a>
          <a href={EXTERNAL_LINKS['DH_FB']} target="_blank" rel="noopener noreferrer">
            <LogoImage src={Facebook} alt="Facebook Logo" />
          </a>
          <a href={EXTERNAL_LINKS['DH_INSTAGRAM']} target="_blank" rel="noopener noreferrer">
            <LogoImage src={Instagram} alt="Instagram Logo" />
          </a>
          <a href={EXTERNAL_LINKS['DH_LINKEDIN']} target="_blank" rel="noopener noreferrer">
            <LogoImage src={LinkedIn} alt="LinkedIn Logo" />
          </a>
        </LogoContainer>
        <ResponsiveText />
        <Text>
          <a href={EXTERNAL_LINKS['MLH_CODE_OF_CONDUCT']} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}> 
            Code of Conduct
          </a>
        </Text>
      </RightFooterContainer>
      <ScrollUp src={UpArrow} alt="Scroll to top" onClick={scrollToTop} style={{ cursor: 'pointer' }} />
    </Section>
  );
}

export default Footer;